import useUser from './useUser';
import axios from 'axios';
import { AxiosResponse } from 'axios';
import { URL_PURCHASE_ORDERS } from 'constants/url';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { IPurchaseDetail, IPurchaseOrderList } from 'interfaces/purchaseOrders.interface';

export default function usePurchaseOrders() {
  const { jwt } = useUser();
  const { showNotistack } = useCustomSnackbar();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getAllPurchaseOrders = async (): Promise<IPurchaseOrderList[]> => {
    return axios.get(`${URL_PURCHASE_ORDERS}`, { headers }).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  const getAllPurchaseOrdersAdmin = async (
    initDate: Date | string,
    finDate: Date | string
  ): Promise<IPurchaseOrderList[]> => {
    return axios
      .get(`${URL_PURCHASE_ORDERS}?initDate=${initDate}&finDate=${finDate}`, { headers })
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch(() => {
        showNotistack({ message: 'Ocurrió un error, por favor comuniquese con el administrador' });
      });
  };

  const getPurchaseOrdersByNumber = async (ocNumber: number): Promise<IPurchaseDetail> => {
    return axios.get(`${URL_PURCHASE_ORDERS}/${ocNumber}`, { headers }).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  return {
    getAllPurchaseOrders,
    getAllPurchaseOrdersAdmin,
    getPurchaseOrdersByNumber
  };
}
